export {
  default,
  getStaticPaths,
  getStaticProps,
} from 'containers/InsightPage/InsightPage';
